/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Action_ApproveInputs */

const en_wb_action_approve = /** @type {(inputs: Wb_Action_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve this example`)
};

const lv_wb_action_approve = /** @type {(inputs: Wb_Action_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apstiprināt šo piemēru`)
};

/**
* | output |
* | --- |
* | "Approve this example" |
*
* @param {Wb_Action_ApproveInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_action_approve = /** @type {((inputs?: Wb_Action_ApproveInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Action_ApproveInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_action_approve(inputs)
	return en_wb_action_approve(inputs)
});